module.exports = __webpack_public_path__ + "static/media/ldr_brd_current_user.bc5999f8.svg";